import { Icon } from "./Icon.tsx";

/** "Inlets" tab icon — a storm-drain grate (a frame with parallel bars,
 * only vertical dividers), distinct from DataIcon.tsx's own spreadsheet
 * grid (1 horizontal + 1 vertical divider forming 4 quadrants). */
export function InletIcon() {
  return (
    <Icon>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M7 6v12M11 6v12M15 6v12" />
    </Icon>
  );
}
